import {
  CREATE_CLAIMFORM_START,
  CREATE_CLAIMFORM_SUCCESS,
  CREATE_CLAIMFORM_FAILURE,
  CREATE_CLAIMFORM_RESET,
  UPDATE_CLAIMFORM_START,
  UPDATE_CLAIMFORM_SUCCESS,
  UPDATE_CLAIMFORM_FAILURE,
  UPDATE_CLAIMFORM_RESET,
  GET_CLAIMFORM_START,
  GET_CLAIMFORM_SUCCESS,
  GET_CLAIMFORM_FAILURE,
  GET_CLAIMFORM_RESET,
  SORT_CLAIMFORM_START,
  SORT_CLAIMFORM_SUCCESS,
  SORT_CLAIMFORM_FAILURE,
  SORT_CLAIMFORM_RESET,
  VIEW_CLAIMFORM_START,
  VIEW_CLAIMFORM_SUCCESS,
  VIEW_CLAIMFORM_FAILURE,
  VIEW_CLAIMFORM_RESET,
  CREATE_CLAIM_LINK,
  CREATE_CLAIM_LINK_SUCCESS,
  CREATE_CLAIM_LINK_FAILED,
  VIEW_CLAIM_LINK,
  VIEW_CLAIM_LINK_SUCCESS,
  VIEW_CLAIM_LINK_FAILED,
  SUBMIT_CLAIM_LINK,
  SUBMIT_CLAIM_LINK_FAILED,
  SUBMIT_CLAIM_LINK_SUCCESS,
  CUSTOMER_POLICY_CLAIM_FAILED,
  CUSTOMER_POLICY_CLAIM_SUCCESS,
  CUSTOMER_POLICY_LOB,
  CUSTOMER_POLICY_CLAIM,
  CUSTOMER_POLICY_LOB_FAILED,
  CUSTOMER_POLICY_LOB_SUCCESS
} from "./actiontypes"


const initialState = {
  error: null,
  responseMsg: null,
  loading: false,
  loadingLOB: false,               
  customerLOBs: [],
  claimForms: [],
  custClaimForm: [],
  claimPolicyInformation: []
}


const ClaimFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CLAIMFORM_START:

      return {
        ...state,
        error: null,
        responseMsg: "",
        loading: true,
      }
    case CREATE_CLAIMFORM_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: action.payload.message,
        claimForms: action.payload,
      }
    case CREATE_CLAIMFORM_FAILURE:
      //console.log(action.error.message)
      return {
        ...state,
        error: action.error.message,
        loading: false,
        responseMsg: ""
      }

    case CREATE_CLAIMFORM_RESET:
      return {
        claimForms: [],
        error: null,
        loading: false,
        responseMsg: "",
      }




    case GET_CLAIMFORM_START:
      return {
        ...state,
        loading: true,
        error: null,
        responseMsg: "",
        claimForms: []
      }

    case GET_CLAIMFORM_SUCCESS:
      //console.log(action.payload.data)
      return {
        ...state,
        loading: false,
        claimForms: action.payload,

      }

    case GET_CLAIMFORM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case GET_CLAIMFORM_RESET:
      return {
        claimForms: [],
        error: null,
        loading: false,
      }

    case UPDATE_CLAIMFORM_START:
      return {
        ...state,
        error: null,
        loading: true,
        responseMsg: "",
      }

    case UPDATE_CLAIMFORM_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        responseMsg: action.payload.message,
      }

    case UPDATE_CLAIMFORM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      }
    case UPDATE_CLAIMFORM_RESET:
      return {
        error: null,
        loading: false,
        responseMsg: "",
      }

    case SORT_CLAIMFORM_START:
      return {
        ...state,
        loading: true,
        error: null,
        responseMsg: "",
        claimForms: [],
      }

    case SORT_CLAIMFORM_SUCCESS:
      // console.log(action.payload.data)
      return {
        ...state,
        loading: false,
        claimForms: action.payload,
        responseMsg: action.payload.message,
      }

    case SORT_CLAIMFORM_FAILURE:
      return {
        ...state,
        loading: false,
        claimForms: [],
        error: action.payload.message,
      }
    case SORT_CLAIMFORM_RESET:
      return {
        claimForms: [],
        error: null,
        loading: false,
        responseMsg: "",
      }
    case VIEW_CLAIMFORM_START:
      return {
        ...state,
        loading: true,
        error: null,
        responseMsg: "",
        claimForms: [],
      }

    case VIEW_CLAIMFORM_SUCCESS:
      //console.log(action.payload.data)
      return {
        ...state,
        loading: false,
        claimForms: action.payload,

      }

    case VIEW_CLAIMFORM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case VIEW_CLAIMFORM_RESET:
      return {
        claimForms: [],
        error: null,
        loading: false,
      }
    case CREATE_CLAIM_LINK:
      return {
        ...state,
        loading: true,
        hashKey: "",
      }
    case CREATE_CLAIM_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: "Link Created Successfully",
        hashKey: action.payload.hashkey
      }

    case VIEW_CLAIM_LINK:
    case SUBMIT_CLAIM_LINK:
      return {
        ...state,
        loading: true
      }
    case VIEW_CLAIM_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        custClaimForm: action.payload
      }
    case SUBMIT_CLAIM_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: "Claim Created Successfully!"
      }
    case CUSTOMER_POLICY_LOB: // start
      return {
        ...state,
        loadingLOB: true,
        error: null,
        customerLOBs: []         // clear old list
      };

    case CUSTOMER_POLICY_LOB_SUCCESS:
      return {
        ...state,
        loadingLOB: false,
        customerLOBs: action.payload || []
      };

    case CUSTOMER_POLICY_LOB_FAILED:
      return {
        ...state,
        loadingLOB: false,
        error: action.payload
      };

    case CUSTOMER_POLICY_CLAIM: // (optional) show loading state
      return {
        ...state,
        loading: true,
        error: null,
        claimPolicyInformation: []
      };

    case CUSTOMER_POLICY_CLAIM_SUCCESS:
      return {
        ...state,
        loading: false,                         // <-- was true; fix it
        claimPolicyInformation: action.payload || []
      };

    case CUSTOMER_POLICY_CLAIM_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CREATE_CLAIM_LINK_FAILED:
    case VIEW_CLAIM_LINK_FAILED:
    case SUBMIT_CLAIM_LINK_FAILED:
    default:
      return state
  }
};

export default ClaimFormReducer;